
import './App.css';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
export default function Withdra() {

  const [formData, setFormData] = useState({
    userName: '',
    userUpi: '',
    userPhone: '',
    amountInRupees: ''
  });

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');


  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };



  const handleWithdraw = async (e) => {

    if (amount < formData.amountInRupees) {
      alert("Insufficient Balance");
    } else {

      e.preventDefault();
      setLoading(true);
      setMessage('');

      try {
        // Aapka Node.js backend URL (e.g., http://localhost:5000)
        const response = await axios.post('https://sagarproperties.netlify.app/.netlify/functions/api/api/withdraw', formData);
        // alert(formData.amountInRupees)
        doWithdraw(formData.amountInRupees);
        setMessage(`Success! Payout ID: ${response.data.payoutId}`);

        console.log("Withdrawal Response:", response.data);
      } catch (error) {
        setMessage("Withdrawal failed. Please check console.");
        console.error("Error:", error.response ? error.response.data : error.message);
      } finally {
        setLoading(false);
      }
    }


  };


  // MERI HARKATE


  const [amount, setAmount] = useState();
  const [lo, setLo] = useState(false);
  function getAmount() {
    setLo(true);
    axios.get(`https://sagarproperties.netlify.app/.netlify/functions/api/money`).then((res) => {
      setAmount(res.data[0].amount);
      setLo(false);
    })
  }

  function doWithdraw(money) {
    setLo(true);
    let final = amount - money
    // console.log("final: " + amount);
    // console.log("final: " + money);
    // console.log("final: " + final);
    axios.post(`https://sagarproperties.netlify.app/.netlify/functions/api/money/test`, { name: 'test', amount: final }).then((res) => {
      setLo(false);
    })
  }


  useEffect((e) => {
    // e.preventDefault();
    getAmount();
  }, [])


  return (
    <>

      <div style={{ padding: '20px', maxWidth: '400px', margin: '0 auto', fontFamily: 'Arial' }}>
        <h2>Withdraw Funds</h2>
        <form onSubmit={handleWithdraw}>
          <div style={{ marginBottom: '10px' }}>
            <label>Full Name:</label>
            <input type="text" name="userName" value={formData.userName} onChange={handleChange} required style={inputStyle} />
          </div>
          <div style={{ marginBottom: '10px' }}>
            <label>UPI ID (VPA):</label>
            <input type="text" name="userUpi" placeholder="example@apl" value={formData.userUpi} onChange={handleChange} required style={inputStyle} />
          </div>
          <div style={{ marginBottom: '10px' }}>
            <label>Phone Number:</label>
            <input type="text" name="userPhone" value={formData.userPhone} onChange={handleChange} required style={inputStyle} />
          </div>
          <div style={{ marginBottom: '10px' }}>
            <label>Amount (INR):</label>
            <input type="number" name="amountInRupees" value={formData.amountInRupees} onChange={handleChange} required style={inputStyle} />
          </div>

          <button type="submit" disabled={loading} style={buttonStyle}>
            {loading ? 'Processing...' : 'Withdraw to Bank/UPI'}
          </button>
        </form>
<br></br>
        <Link to="/dash"> <button style={buttonStyle}>Dashboard
        </button></Link>
        {message && <p style={{ marginTop: '15px', color: message.includes('Success') ? 'green' : 'red' }}>{message}</p>}
      </div>

      {
        lo ?
          <>
            <div class="lo">
              <h1>Waiting....</h1>
            </div>
          </>
          : null
      }
    </>
  )
}


const inputStyle = { width: '100%', padding: '8px', marginTop: '5px', borderRadius: '4px', border: '1px solid #ccc' };
const buttonStyle = { width: '100%', padding: '10px', backgroundColor: '#3395ff', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' };
